import { Component, Vue } from 'vue-property-decorator'
import DefaultLayout from '@/components/Layouts/Default'
import GameFooter from '@/components/Game/Footer';
import { Auth } from 'aws-amplify';
import { EventBus } from '@/utils/eventbus';
import Axios from 'axios';
import { config } from '@/../app.config'
import _ from 'lodash';
import { FormatCurrency } from '@/utils/GameUtils';

export interface IPaymentSession {
  session: string,
  sessionurl: string,
}

@Component
export default class Account extends Vue {

  private logout() {
    this.$router.push('signout')
  }
  
  private render(h: any) {
    const balance = `${FormatCurrency(this.$store.getters.BALANCE)}`

    return (
        <DefaultLayout>
          <div slot='navigation'>
            <h1 class='navigation-title'>{this.$route.meta.title}</h1>
            <router-link class='navigation-link home' to='/lobby'>Game</router-link>
            <p class='navigation-user'>{this.$store.getters.USERNAME}</p>
            <router-link class='navigation-balance' to='/account'>{balance}</router-link>
          </div>

          <div class='account-balance'>
          <span>Balance</span>
            <p class='account-balance-amount'>{balance}</p>
          </div>

          <div class='account-actions'>

            <div class='account-action deposit'>
              <router-link class='navigation-link' to='/addfunds'>Add Funds</router-link>
              <span>&gt;</span>
            </div>
            
            <div class='account-action'>
              <router-link class='navigation-link' to='/wallet'>View Payment History</router-link>
              <span>&gt;</span>
            </div>

            <div class='account-action'>
              <router-link class='navigation-link' to='/withdrawal'>Request Withdrawal</router-link>
              <span>&gt;</span>
            </div>

            <div class='account-action'>
              <router-link class='navigation-link' to='/drafthistory'>Ticket History</router-link>
              <span>&gt;</span>
            </div>

            <div class='account-action tall'>
              <a href='mailto:support@quickpicks.com'>Contact support
                <span class='supplementary'>Replies from support may go to spam folders</span>
              </a>
              <span>&gt;</span>
            </div>

            <div class='account-action'>
              <a onClick={this.logout.bind(this)}>Logout</a>
              <span>&gt;</span>
            </div>
          </div>

          <GameFooter></GameFooter>
        </DefaultLayout>
    );
  }
}
